import { useVsiAppContext } from "../../stores/VsiApp";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Input, Row, UncontrolledTooltip } from "reactstrap";
import { VsiLgText, VsiMedLabel, VsiMedText } from "../../styled/App.styled";
import { withErrorBoundary } from "../../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../../boundaries/GeneralErrorBoundary";
import { numberInputOnWheelPreventChange } from "../../utils/Helpers";

function CustomHostCard ({ host, addCustomHost }) {
  	const { theme } = useVsiAppContext();

    const [cpu, setCpu] = useState(host?.cpu ?? null);
    const [mem, setMem] = useState(host?.mem ?? null);
    const [disk, setDisk] = useState(host?.disk ?? null);
    const [model, setModel] = useState(host?.model ?? '');
    const [costCpu, setCostCpu] = useState(host?.cost_per_cpu ?? null);
    const [costMem, setCostMem] = useState(host?.cost_per_memory ?? null);
    const [costDisk, setCostDisk] = useState(host?.cost_per_disk ?? null);

    const onChange = e => {
      const { name, value } = e.target;
      if (value >= 0) {
        if (name === "cpu") {
          setCpu(parseFloat(value));
        } else if (name === "mem") {
          setMem(parseFloat(value));
        } else if (name === "disk") {
          setDisk(parseFloat(value));
        } else if (name === "cost_per_cpu") {
          setCostCpu(parseFloat(value));
        } else if (name === "cost_per_memory") {
          setCostMem(parseFloat(value));
        } else if (name === "cost_per_disk") {
          setCostDisk(parseFloat(value));
        }
      }
      if (name === "model") {
        setModel(value);
      }
    }

    const onApplyClick = () => {
      addCustomHost({
        cpus: cpu || 0,
        memory_size: mem || 0,
        disk_size: disk || 0,
        model,
        cost_per_cpu: costCpu || 0,
        cost_per_memory: costMem || 0,
        cost_per_disk: costDisk || 0,
        isCustom: true,
        model_count: 1,
        modelCountAdded: 0
      });
	  }

    useEffect(() => {
      setCpu(host?.cpu ?? 0);
      setMem(host?.mem ?? 0);
      setDisk(host?.disk ?? 0);
      setModel(host?.model ?? '');
      setCostCpu(host?.cost_per_cpu ?? 0);
      setCostMem(host?.cost_per_memory ?? 0);
      setCostDisk(host?.cost_per_disk ?? 0);
	}, [host]);

    return (
          <Card color={theme} className={"my-2"}>
            <CardHeader>
                <Row>
                  <Col xs={9}>
                    <VsiLgText textAlign={"left"} style={{ fontStyle: 'italic' }}>* Custom ESX Host <VsiMedText>(capacity)</VsiMedText></VsiLgText>
                  </Col>
                  <Col xs={3} className={"d-flex flex-row justify-content-end"}>
                    <Button color={'warning'}
                            disabled={!model}
                            id="add-to-chart"
                            onClick={onApplyClick}>
                      <i className={"fa-sharp fa-solid fa-plus"}/>
                    </Button>
                    <UncontrolledTooltip placement={"bottom"} target={"add-to-chart"}>
                      Add custom ESX host
                    </UncontrolledTooltip>
                  </Col>
                </Row>
              </CardHeader>
            <CardBody>
              <Row>
                <Col xs={12} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>Custom Host Model Name</VsiMedLabel>
                  <Input value={model}
                         type={"text"}
                         onChange={onChange}
                         name={"model"}/>
                </Col>
                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>vCPU</VsiMedLabel>
                  <Input value={cpu}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"cpu"}/>
                </Col>
                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>Memory (GiB)</VsiMedLabel>
                  <Input value={mem}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"mem"}/>
                </Col>
                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>Disk (GiB)</VsiMedLabel>
                  <Input value={disk}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"disk"}/>
                </Col>
                                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>$ / vCPU</VsiMedLabel>
                  <Input value={costCpu}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"cost_per_cpu"}/>
                </Col>
                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>$ / Memory (GiB)</VsiMedLabel>
                  <Input value={costMem}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"cost_per_memory"}/>
                </Col>
                <Col xs={4} className={"d-flex flex-column justify-content-between"}>
                  <VsiMedLabel textAlign={"left"}>$ / Disk (GiB)</VsiMedLabel>
                  <Input value={costDisk}
                         type={"number"}
                         onWheel={numberInputOnWheelPreventChange}
                         onChange={onChange}
                         name={"cost_per_disk"}/>
                </Col>
              </Row>
            </CardBody>
          </Card>
    )
}

export default withErrorBoundary(CustomHostCard, GeneralErrorBoundary);
